import ShapeBase from './ShapeBase';
import weakEntity from '../assets/icons/weak_entity.svg';
import { svgToIcon } from '../utils/svg';
import type Shape from '../objects/Shape';

class ShapeWeakEntity extends ShapeBase {
  constructor(fabricObject: Shape) {
    super(fabricObject);

    // Set min scale to avoid drawing inner lines outside of shape
    fabricObject.minScaleLimit = (this.offset() / 100) * 2.5;
  }

  static renderIcon() {
    return svgToIcon(weakEntity);
  }

  offset() {
    return 10;
  }

  calcTextMargin() {
    return {
      top: this.offset(),
      left: this.offset(),
      right: this.offset(),
      bottom: this.offset(),
    };
  }

  render(ctx: CanvasRenderingContext2D) {
    const obj = this.fabricObject;
    const { width: w, height: h } = obj;

    const top = -h / 2 + this.verticalOffset();
    const bottom = h / 2 - this.verticalOffset();
    const left = -w / 2 + this.horizontalOffset();
    const right = w / 2 - this.horizontalOffset();

    ctx.beginPath();
    this._setBorderDash(ctx);

    ctx.moveTo(-w / 2, -h / 2);
    ctx.lineTo(w / 2, -h / 2);
    ctx.lineTo(w / 2, h / 2);
    ctx.lineTo(-w / 2, h / 2);
    ctx.closePath(); // close path to avoid issue with thick borders
    ctx.moveTo(left, top);
    ctx.lineTo(right, top);
    ctx.lineTo(right, bottom);
    ctx.lineTo(left, bottom);
    ctx.lineTo(left, top);
    ctx.closePath();

    obj._renderPaintInOrder(ctx);
  }
}

export default ShapeWeakEntity;
